@for (komponentType of komponentTyper; track komponentType; let i = $index) {
  <div
    (click)="this.vaelg.emit(komponentType)">
    {{ komponentType.navn }} {{ hentKanFaktureresTekst(komponentType.kanFaktureres) }}
  </div>
}
